export function isDivertLane(divertLaneCode: string): boolean {
  const pattern = /^AS\d+-DL\d+$/;
  return pattern.test(divertLaneCode);
}
